import ReactApexChart from 'react-apexcharts';
import axios from 'axios';
import { useEffect, useState } from 'react';
import ChartLoader from './ChartLoader';

const Chart = ({ selectedMetal, selectedDuration }) => {
  const [res, setRes] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const calculateFromDate = (duration) => {
      const today = new Date();
      if (duration === '1D') today.setDate(today.getDate() - 1);
      else if (duration === '1W') today.setDate(today.getDate() - 7);
      else if (duration === '1M') today.setMonth(today.getMonth() - 1);
      else if (duration === '3M') today.setMonth(today.getMonth() - 3);
      else if (duration === '6M') today.setMonth(today.getMonth() - 6);
      else if (duration === '1Y') today.setMonth(today.getMonth() - 12);
      else throw new Error('Invalid duration');
      return today.toISOString().slice(0, 10);
    };

    const calculatedFromDate = calculateFromDate(selectedDuration);

    const data = JSON.stringify({
      metalCode: selectedMetal,
      fromDate: calculatedFromDate,
    });

    const config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: 'https://api.ebullion.in/price/chart/new',
      headers: {
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*',
      },
      data: data,
    };

    setLoading(true);
    axios
      .request(config)
      .then((response) => {
        const rawData = response?.data?.data || [];

        const processedData = (selectedDuration === '3M' || selectedDuration === '6M')
          ? downsample(rawData, 1000)
          : rawData;

        setRes(processedData);
        setLoading(false);
      })
      .catch((error) => {
        console.error("Chart fetch error:", error);
        setLoading(false);
      });
  }, [selectedMetal, selectedDuration]);

  const downsample = (data, maxPoints = 1000) => {
    const factor = Math.ceil(data.length / maxPoints);
    return data.filter((_, i) => i % factor === 0);
  };

  const options = {
    chart: {
      id: 'area-datetime',
      type: 'area',
      height: 350,
      width: 500,
      zoom: {
        autoScaleYaxis: true,
      },
      animations: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    title: {
      text: 'Pricing Chart',
      align: 'left',
    },
    yaxis: {
      title: {
        text: 'Price (INR)',
      },
    },
    colors: ['#99834d'],
    stroke: {
      curve: 'straight',
      width: 1,
    },
    markers: {
      size: 0, // remove point markers
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      x: {
        format: 'dd MMMM yyyy hh:mm TT',
      },
    },
    xaxis: {
      type: 'datetime',
      min: res.length > 0 ? new Date(res[0]?.x).getTime() : undefined,
      tickAmount: 6,
    },
  };

  const series = [
    {
      name: 'INR / g',
      data: res,
    },
  ];

  return (
    <div className='area-line-chart'>
      {loading ? (
        <ChartLoader />
      ) : (
        <ReactApexChart
          options={options}
          series={series}
          type='area'
          height={450}
          width={1000}
        />
      )}
    </div>
  );
};

export default Chart;

